import { on as onEvent } from "common/utils/ui/event";
import "./faq.scss";

const SHOWN_CLASS = "faq-open";
let initialized = false;

const initJiffymadeLandingFaq = () => {
  if (initialized) return;
  initialized = true;

  onEvent("click", ".js-jiffymade-landing-print-faq-link", (_, $target) => {
    const $parent = $target.parentElement;
    if (!$parent || !$parent.classList.contains("js-jiffymade-landing-print-faq-item")) return;

    $parent.classList.toggle(SHOWN_CLASS);
  });
};

export default initJiffymadeLandingFaq;
